<template>
    <div>
        <div id="HTU" style="padding-left:20px; padding-right:20px">
            <div style="text-align:center">
                <h1>{{ this.$t('ujian.how-to-use.title') }}</h1>
            </div>
            <a-divider />
            <!-- <vue-scroll :ops="ops"> -->
 <div class="child-wrap">
                Sebelum anda (calon mahasiswa ITB STIKOM Bali) melakukan ujian secara online pastikan beberapa hal berikut:
                <table>
                    <tr>
                        <td style="width:10px"><b>A.</b></td>
                        <td>Pastikan anda menggunakan laptop/desktop untuk mempermudah dalam pengerjaan ujian online.</td>
                    </tr>
                    <tr>
                        <td style="width:10px"><b>B.</b></td>
                        <td>Pastikan koneksi anda baik dan lancar selama ujian online berlangsung.</td>
                    </tr>
                </table> 

                <br>
                Berikut tata cara dalam penggunaan sistem ujian online, sehingga dapat mempermudah dalam pengenalan interface (antarmuka) dalam mengerjakan soal ujian online.
                <table>
                    <tr>
                        <td style="width:10px"><b>A.</b></td>
                        <td>Setelah Halaman ini anda akan masuk ke halaman Mulai Ujian, dengan tampilan sebagai berikut</td>
                    </tr>
                    <tr>
                        <td style="width:10px"></td>
                        <td><img src="@/assets/img/ujianonline/mulaiujian.png" alt="mulaiujian" class="responsive" height="300"/></td>
                    </tr>
                    <tr>
                        <td style="width:10px"></td>
                        <td>Silahkan memilih salah satu kategori ujian pada kotak yang berwarna merah. Terdapat 4 buah kategori soal ujian antara lain : 
                            <ul>
                                <li>Pengetahuan Umum</li>
                                <li>Bahasa Inggris</li>
                                <li>Komputer</li>
                                <li>Matematika</li>
                            </ul> 
                            <br>
                            Setelah memilih salah satu kategori ujian, maka selanjutnya dapat mengklik tombol <b>Mulai Ujian</b>
                        </td>
                    </tr>
                    <tr>
                        <td style="width:10px"><b>B.</b></td>
                        <td>Sistem menampilkan halaman ujian anda dengan kategori ujian yang telah anda pilih seperti pada gambar berikut</td>
                    </tr>
                    <tr>
                        <td style="width:10px"></td>
                        <td><img src="@/assets/img/ujianonline/halujian.png" alt="halamanujian" class="responsive" height="300"/></td>
                    </tr>
                    <tr>
                        <td style="width:10px"></td>
                        <td>Pada Halaman ini terdapat beberapa kotak yakni merah, biru dan hijau adapun pengertiaannya sebagai berikut
                            <ul>
                                <li>Kotak Merah merupakan Kategori Soal Ujian yang digunakan dalam ujian dengan informasi jumlah soal (warna biru), jumlah yang telah dijawab (warna hijau) dan jumlah sisa soal (warna merah)</li>
                                <li>Kotak Biru merupakan tempat pengerjaan soal secara online dimana terdapat pertanyaan dan jawaban pada halaman ini</li>
                                <li>Kotak Hijau menjelaskan sisa waktu dalam pengerjaan soal online serta nomer soal yang harus dijawab oleh peserta</li>                            
                            </ul>                         
                        </td>
                    </tr>
                    <tr>
                        <td style="width:10px; vertical-align:top"><b>C.</b></td>
                        <td>Beberapa pertanyaan dalam ujian online (Q : Question, A : Answer)
                            <table>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana caranya menjawab soal ujian?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>A.</b></td>
                                    <td>Silahkan memilih salah satu jawaban antara A, B, C atau D pada halaman ujian <b>(B)</b> pada kotak yang berwarna biru </td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana caranya mengganti soal ujian?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>A.</b></td>
                                    <td>Silahkan mengklik tombol "Selanjutnya" atau "Sebelumnya" pada halaman ujian 
                                        <b>(B)</b> pada kotak yang berwarna biru. Penggantian soal juga bisa dilakukan pada halaman ujian 
                                        <b>(B)</b> pada kotak yang berwarna hijau dengan mengklik salah satu nomer soal yang ingin dikerjakan </td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana caranya melewati soal atau menandai soal?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>A.</b></td>
                                    <td>Silahkan memilih tombol "Tandai Soal" pada halaman ujian <b>(B)</b> pada kotak yang berwarna biru, kemudian sialhkan memilih soal selanjutnya</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana caranya melihat soal yang telah dijawab atau belum dijawab?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>A.</b></td>
                                    <td>Dapat dilihat pada kategori soal pada halaman ujian <b>(B)</b> pada kotak yang berwarna merah. Terdapat 3 buah warna dengan informasi jumlah soal (warna biru), jumlah yang telah dijawab (warna hijau) dan jumlah sisa soal (warna merah)</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Jika soal pada satu kategori soal telah selesai dijawab, apa langkah selanjutnya</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>A.</b></td>
                                    <td>Sistem akan menampilkan sebuah pesan untuk melakukan penggantian kategori soal ujian, kemudian silahkan memilih kategori soal selanjutnya yang belum selesai dikerjakan</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Jika soal pada satu kategori soal belum selesai dijawab, apakah bisa mengganti ke kategori soal berikutnya? dan Bagaimana Caranya?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Bisa. Caranya adalah dengan mengklik tombol "Ganti Kategori Soal" pada halaman ujian <b>(B)</b> pada kotak yang berwarna biru. Sistem akan menampilkan sebuah message untuk mengganti kategori soal. </td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Jika soal pada satu kategori soal telah selesai dijawab, dan nantinya akan kembali lagi ke kategori tersebut apakah bisa? dan Bagaimana Caranya?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Bisa. Caranya adalah dengan mengklik tombol "Ganti Kategori Soal" pada halaman ujian <b>(B)</b> pada kotak yang berwarna biru. Sistem akan menampilkan sebuah message untuk mengganti kategori soal. </td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Jika soal pada semua kategori soal telah selesai dijawab, apa yang akan terjadi selanjutnya?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Sistem akan memberikan notifikasi bahwa semua kategori soal telah selesai dijawab</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana jika waktu ujian telah berakhir pada saat waktu ujian</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Sistem akan memberikan notifikasi bahwa waktu telah habis, jawaban akan tersimpan secara otomatis</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana jika saya ingin keluar dari sistem sedangkan waktu belum habis</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Dapat dilakukan dengan mengklik ikon "shutdown" pada halaman ujian <b>(B)</b> pada kotak yang berwarna hijau. Selanjutnya sistem akan menampilkan konfirmasi untuk keluar dari sistem.</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Bagaimana jika komputer saya mati/koneksi terputus/halaman ujian keluar?</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Sistem akan menyimpan jawaban anda secara otomatis setelah anda menjawab soal.</td>
                                </tr>
                                <tr>
                                    <td style="width:10px; vertical-align:top"><b>Q.</b></td>
                                    <td><b>Jika sudah pernah melakukan ujian, apakah dapat melakukan ujian kembali</b></td>
                                </tr>
                                <tr>
                                    <td style="width:10px;  vertical-align:top"><b>A.</b></td>
                                    <td>Tidak.</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr >
                        <td style="width:10px; vertical-align:top; padding-top:50px;"><b>D.</b></td>
                        <td style="padding-top:50px;">Jika anda telah mengerti dalam penggunaan sistem online ini, silahkan memulai ujian online dengan klik tombol "Selanjutnya" </td>
                    </tr>
                    
                </table> 
 </div>
            <!-- </vue-scroll> -->
        </div>
    </div>
</template>

<script>
//   import VueScroll from 'vuescroll';
  export default {
    //   components:{
    //     VueScroll
    //   },
    data() {
      return {
        
      
      }
    }
  }
</script>